export default class Token {
    constructor (accessToken, refreshToken) {
      this.accessToken = accessToken
      this.refreshToken = refreshToken
    }
  }
